var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ParticipantShiftsTableHeader } from '../../../../../ui/features/shift-details/components/participant-details-tables/ParticipantShiftsTableHeader';
import { useAdminShiftParticipantsTableColumns } from '../../../../../ui/features/shift-details/hooks/useAdminShiftParticipantsTableColumns';
import { useSelectActionsShiftParticipantsTable } from '../../../../../ui/features/shift-details/hooks/useSelectActionsShiftParticipantsTable';
import { useShiftParticipantsTableActions } from '../../../../../ui/features/shift-details/hooks/useShiftParticipantsTableActions';
import { useShiftParticipantsTableDataProvider } from '../../../../../ui/features/shift-details/hooks/useShiftParticipantsTableDataProvider';
import { useAddVolunteers } from '../../../../../ui/features/volunteers-wizard-dialog/hooks/useAddVolunteers';
import { useShiftVolunteerManagementWizardSteps } from '../../../../../ui/features/volunteers-wizard-dialog/hooks/useShiftVolunteerManagementWizardSteps';
import { useMissionsTranslation } from '../../../../../ui/hooks';
import { MissionContext } from '../../../../../ui/providers';
import { DataTable, TablePaginationContent, useDataTableUsingState } from '@juvare/common-data-table-ui/DataTable';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import SupervisorAccountOutlinedIcon from '@mui/icons-material/SupervisorAccountOutlined';
import { Box, Typography } from '@mui/material';
import React from 'react';
export const AdminShiftParticipantsTable = ({ row, defaultRowsPerPage, onSendMessageToVolunteers, fetchAnalytics, }) => {
    var _a, _b, _c;
    const { dataTableProps } = useDataTableUsingState({
        useDataProvider: (request) => useShiftParticipantsTableDataProvider(request, {
            shiftId: row.id,
        }),
        defaultSortColumnKey: '',
        defaultRowsPerPage,
        rowSelectionEnabled: true,
    });
    const { rows: shiftParticipants, filteredRowCount: totalParticipantCount, customBackendResponseData } = dataTableProps;
    const fetchReload = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        yield ((_a = customBackendResponseData === null || customBackendResponseData === void 0 ? void 0 : customBackendResponseData.mutate) === null || _a === void 0 ? void 0 : _a.call(customBackendResponseData).then(() => {
            fetchAnalytics();
        }));
    });
    const { selectPositionStep, selectVolunteersStep } = useShiftVolunteerManagementWizardSteps();
    const { onAddVolunteers } = useAddVolunteers({
        data: { shift: { id: row.id } },
        onAfterSubmit: fetchReload,
        steps: [selectPositionStep(), selectVolunteersStep()],
    });
    const { handleSelectAll, handleSingleSelect, selected, selectedIds } = useSelectActionsShiftParticipantsTable(shiftParticipants.map(({ id }) => id));
    const columns = useAdminShiftParticipantsTableColumns({
        fetchReload,
    });
    const globalActions = useShiftParticipantsTableActions({
        shiftId: row.id,
        onSendMessageToVolunteers,
        selected,
        selectedIds,
        missionStatus: row.missionStatus || 'draft',
        totalApprovedRequests: (_b = (_a = row.approvedParticipantsIds) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0,
        numberOfRequiredParticipants: (_c = row.totalParticipantSlots) !== null && _c !== void 0 ? _c : 0,
        onAddVolunteers,
        fetchReload,
    });
    const { onParticipantSelect } = React.useContext(MissionContext);
    if (!shiftParticipants) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(DataTable, Object.assign({}, dataTableProps, { columns: columns, hideHeader: true, title: React.createElement(ShiftParticipantsTableTitle, null), headerSx: {
            borderBottom: `1px solid ${themeColors.border.main}`,
            py: 2,
            px: 1,
            mb: 0,
            pl: 4,
            position: 'relative',
        }, onRowClick: (row) => onParticipantSelect(row.columns.participantId), selectedRowIds: selectedIds, totalRowCount: row.totalParticipantSlots, globalActions: globalActions, onRowSelectionChange: (row) => handleSingleSelect({ id: row.id, hoursStatus: row.columns.hoursStatus }), customTableSurfaceComponent: ({ children }) => React.createElement(Box, null, children), customHeaderElement: React.createElement(ParticipantShiftsTableHeader, { onClick: () => handleSelectAll(selectedIds), selectedShifts: selectedIds, totalShifts: totalParticipantCount }), customTablePaginationContentComponent: (props) => (React.createElement(Box, { sx: { mt: 2 } },
            React.createElement(TablePaginationContent, Object.assign({}, props)))) })));
};
const ShiftParticipantsTableTitle = () => {
    const { t } = useMissionsTranslation();
    return (React.createElement(React.Fragment, null,
        React.createElement(SupervisorAccountOutlinedIcon, { sx: { position: 'absolute', left: 0, top: '50%', transform: 'translateY(-50%)' } }),
        React.createElement(Box, { sx: { display: 'inline', position: 'relative' } },
            React.createElement(Typography, { sx: { display: 'inline' }, variant: 'subtitle2' }, t('missions.missionDetails.shiftRoster')))));
};
